// extracted by mini-css-extract-plugin
export var borderRadius = "_9n-4";
export var large = "_9n-3";
export var logoContainer = "_9n-0";
export var nameLogo = "_9n-2";
export var small = "_9n-1";